





































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  @Prop() apps!: any[];

  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const res = await this.$store.dispatch("workorders/addphrase", {
              ...values
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          }
        });
      }
    });
  }
}
